<template>
  <div>
    <img id="mySpinner" src="loading.gif" v-show="loading" class="center-block" />

    <nav
      class="navbar navbar-default navbar-options"
      role="navigation"
      v-show="!loading"
    >
      <div class="container">
        <div class="navbar-header">
          <div class="back-button">
            <button type="button" class="btn btn-back" @click="voltar()">
              <span class="glyphicon glyphicon-menu-left"></span>
              <span class="sr-only">Submit</span>
            </button>
            <span class="restaurantname"> {{ restaurantName }}</span>
          </div>
        </div>
      </div>
    </nav>

    <div class="container-fluid" v-show="!loading">
      <div class="alert alert-danger" v-if="msgError">
        {{msgError}}
      </div>

      <form>
        <div class="form-group">
          <strong>Informe seu nome completo:</strong>
          <br /><br />
          <input
            id="clientName"
            type="text"
            class="form-control"
            @change="msgError = false"
            v-model="client.name"
            required
            style="text-transform: capitalize;"
            placeholder="Informe seu nome completo"
            autocomplete="off"
          />
        </div>
      </form>

      <div id="divSpace"></div>
    </div>

    <div
      class="btn-group btn-group-justified"
      role="group"
      v-show="!loading"
      style="position:fixed; bottom:0; width:100%;"
    >
      <div class="btn-group" role="group">
        <button class="btn btn-danger btn-lg" @click="confirmar()" data-dir="up">
          Próximo
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ClientName',
  data () {
    return {
      loading: false,
      msgError: null,
      client: {}
    }
  },
  computed: {
    aberto: {
      get () {
        return this.$store.state.aberto
      },
      set (value) {
        this.$store.commit('setAberto', value)
      }
    },
    token () {
      return this.$store.state.token
    },
    channelId () {
      return this.$store.state.channelId
    },
    clientId () {
      return this.$store.state.clientId
    },
    code () {
      return this.$store.state.code
    },
    demo () {
      return this.$store.state.demo
    },
    restaurantName () {
      return this.$store.state.restaurantName
    }
  },
  mounted () {
    const vm = this
    vm.loading = true
    vm.axios.get(`${process.env.VUE_APP_API_URL}/sessions`, {
      headers: {
        Authorization: vm.token
      }
    }).then(response => {
      if (!response.data) {
        // closeWebview()
      } else {
        if (vm.token) {
          if (!response.data) {
            // closeWebview()
          } else {
            console.log('buscando dados do cliente')
            vm.axios.get(`${process.env.VUE_APP_API_URL}/clients`, {
              headers: {
                Authorization: vm.token
              }
            }).then(response => {
              console.log('Cliente response')
              vm.client = response.data ? response.data : {}
              vm.client.name = ''
              vm.loading = false
              document.getElementById('clientName').focus()
              console.log('Dados do cliente carregados.')
            }).catch(error => {
              console.log('Problema ao carregar dados do cliente.')
              console.log('Error: ' + error)
              // closeWebview()
            })
          }
        }
      }
    }).catch(error => {
      console.log('Problema ao carregar telefone.')
      console.log('Error: ' + error)
      // closeWebview()
    })
  },
  methods: {
    confirmar () {
      const vm = this
      vm.loading = true

      if (!vm.client.name) {
        vm.msgError = 'Precisamos do seu nome completo'
        return (vm.loading = false)
      }
      vm.axios.put(`${process.env.VUE_APP_API_URL}/sessions`,
        { client: vm.client },
        {
          headers: {
            Authorization: vm.token
          }
        }
      ).then(() => {
        vm.axios.patch(`${process.env.VUE_APP_API_URL}/clients`,
          { name: vm.client.name },
          {
            headers: {
              Authorization: vm.token
            }
          }
        ).then(() => {
          // Se cliente ainda não informou e-mail levar para página
          if (!vm.client.email) {
            vm.$router.push({
              path: vm.code ? `/${vm.code}/email` : `/email/${vm.channelId}/${vm.clientId}`
            })
          } else {
            vm.$router.push({
              path: vm.code ? `/${vm.code}/cart` : `/cart/${vm.channelId}/${vm.clientId}`
            })
          }
          vm.loading = false
        })
      }).catch(error => {
        vm.loading = false
        console.log('Falha ao atualizar dados da sessão.')
        console.log(`Error: ${error}`)
      })
    },

    cancelar () {
      console.log('Cancelar')
      // closeWebview()
    },

    voltar () {
      window.history.back()
    }
  }
}
</script>
